import { APP_INITIALIZER, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { routes } from './auth.routes';
import { LoginComponent } from './components/login/login.component';
import { initializeSession } from './initializers/session.initializer';
import { LogoutComponent } from './components/logout/logout.component';
import { OauthCallbackComponent } from './components/oauth-callback/oauth-callback.component';
import { SessionService } from './services/session.service';

@NgModule({
  declarations: [LoginComponent, LogoutComponent, OauthCallbackComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes)],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSession,
      deps: [SessionService],
      multi: true,
    },
  ],
})
export class AuthModule {}
